import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;
`

export const TooltipContent = styled.div<{ $position: 'top' | 'bottom' | 'left' | 'right' }>`
  position: absolute;
  z-index: 9999;
  background-color: ${Tokens.ColorTextPrimary};
  color: ${Tokens.ColorWhite};
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  max-width: 420px;
  min-width: 280px;
  white-space: normal;
  word-wrap: break-word;

  ${({ $position }) => {
    switch ($position) {
      case 'top':
        return `
          bottom: calc(100% + 12px);
          left: 50%;
          transform: translateX(-50%);
          
          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: ${Tokens.ColorTextPrimary};
          }
        `
      case 'bottom':
        return `
          top: calc(100% + 12px);
          left: 50%;
          transform: translateX(-50%);
          
          &::after {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-bottom-color: ${Tokens.ColorTextPrimary};
          }
        `
      case 'left':
        return `
          right: calc(100% + 12px);
          top: 50%;
          transform: translateY(-50%);
          
          &::after {
            content: '';
            position: absolute;
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-left-color: ${Tokens.ColorTextPrimary};
          }
        `
      case 'right':
        return `
          left: calc(100% + 12px);
          top: 50%;
          transform: translateY(-50%);
          
          &::after {
            content: '';
            position: absolute;
            right: 100%;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-right-color: ${Tokens.ColorTextPrimary};
          }
        `
    }
  }}
`
